import Glide from '@glidejs/glide';
import { RTJS_lightbox } from '@rtsoft/rtjs';
import '../../polyfills';
// import { renderLightBox } from './react/lightbox/lightbox'

const getThumbnailElementByDataIndex = (sliderId, dataIndex) =>
    document.querySelector(`#${sliderId} > [data-index="${dataIndex}"]`);

const selectThumbnail = (sliderId, dataIndex) => {
    const element = getThumbnailElementByDataIndex(sliderId, dataIndex);
    if (element) {
        element.classList.add('active');
    }
};

const removeSliderClonesFromLightbox = (slider) => {
    const clones = slider._c.Clones.items;
    if (!clones || clones <= 0) {
        return;
    }
    for (const clone of clones) {
        if (clone.dataset && clone.dataset['rtLightboxGallery']) {
            delete clone.dataset['rtLightboxGallery'];
        }
    }
};

const listenOnThumbnailsClickEvent = (mainSlider) => {
    const thumbnailElements = document.getElementById('thumbnails-gallery__slider').children;

    if (thumbnailElements && thumbnailElements.length > 0) {
        for (const thumbnailElement of thumbnailElements) {
            thumbnailElement.addEventListener('click', () => {
                const mainImageSlider = document.getElementById('product-main-image__slider');

                if (mainImageSlider.children) {
                    mainSlider.go('=' + thumbnailElement.dataset['index']);
                }
            });
        }
    }
};

const changeActiveThumbnail = (thumbnailSliderId, activeThumbnailIndex) => {
    const activeElement = document.querySelector(`#${thumbnailSliderId} > .active`);
    if (activeElement) {
        activeElement.classList.remove('active');
    }

    const element = getThumbnailElementByDataIndex(thumbnailSliderId, activeThumbnailIndex);

    if (activeThumbnailIndex === document.getElementById(thumbnailSliderId).children.length - 1) {
        if (element.classList.contains('invisible')) {
            element.classList.remove('invisible');

            const thumbnailElements = document.getElementById('thumbnails-gallery__slider').children;
            for (const thumbnailElement of thumbnailElements) {
                if (thumbnailElement.dataset.index < thumbnailElements.length - 5) {
                    thumbnailElement.classList.add('invisible');
                } else {
                    thumbnailElement.classList.remove('invisible');
                }
            }
        }
    } else if (activeThumbnailIndex === 0) {
        if (element.classList.contains('invisible')) {
            element.classList.remove('invisible');

            const thumbnailElements = document.getElementById('thumbnails-gallery__slider').children;
            for (const thumbnailElement of thumbnailElements) {
                if (thumbnailElement.dataset.index > 4) {
                    thumbnailElement.classList.add('invisible');
                } else {
                    thumbnailElement.classList.remove('invisible');
                }
            }
        }
    } else {
        if (element.classList.contains('invisible')) {
            const movingLeft = element.previousElementSibling.classList.contains('invisible');

            if (movingLeft) {
                element.classList.remove('invisible');

                const thumbnailElements = document.getElementById('thumbnails-gallery__slider').children;
                for (let index = 0; index < thumbnailElements.length; index++) {
                    const element = thumbnailElements[thumbnailElements.length - index - 1];
                    if (!element.classList.contains('invisible')) {
                        element.classList.add('invisible');
                        break;
                    }
                }
            } else {
                element.classList.remove('invisible');
                document.querySelector(`#${thumbnailSliderId} > li:not(.invisible)`).classList.add('invisible');
            }
        }
    }

    selectThumbnail(thumbnailSliderId, activeThumbnailIndex);
};

const initThumbnailSlider = (thumbnailSliderId) => {
    selectThumbnail(thumbnailSliderId, 0);
    const thumbnailElements = document.getElementById(thumbnailSliderId).children;

    for (const thumbnailElement of thumbnailElements) {
        if (thumbnailElement.dataset.index > 4) {
            thumbnailElement.classList.add('invisible');
        }
    }
};

document.addEventListener('DOMContentLoaded', () => {
    const sliders = {};

    // inicializace slideru obrázků produktu (detail -> hlanví obrázek)
    if (document.body.querySelector('.product-main-image') && document.body.querySelector('[data-glide-el="track"]')) {
        sliders.productMainSlider = new Glide('.product-main-image', {
            autoplay: false,
            perView: 1,
            type: 'carousel',
            gap: 0,
            rewind: false,
        });

        sliders.productMainSlider.on('mount.after', () => {
            initThumbnailSlider('thumbnails-gallery__slider');

            // Fix clones displayed in RTJS
            removeSliderClonesFromLightbox(sliders.productMainSlider);
        });

        sliders.productMainSlider.on('run', () => {
            changeActiveThumbnail('thumbnails-gallery__slider', sliders.productMainSlider.index);
        });

        // RT lightbox

        RTJS_lightbox('.product-main-image__slider .glide__slide', {
            // closeLabel: 'zavřít',
            // showTitle: true,
            // showArrows: true,
            // showThumbnails: true,
            // debug: false,
            // imageErrorLabel: 'obrázek se nepodařilo načíst',
        });

        sliders.productMainSlider.mount();

        listenOnThumbnailsClickEvent(sliders.productMainSlider);
    }
});
